import getAddressByPostalCode from './get-address-by-postal-code';

export const address = {
  getAddressByPostalCode,
};
